import type { Ecriture } from '@shared/types/Ecriture';

export interface AgregatAnalytique {
  code: string;
  produits: number;
  charges: number;
  resultat: number;
}

/**
 * Agrege les ecritures par axe analytique (centre de cout ou projet).
 * Classe 6 -> charges, Classe 7 -> produits.
 */
export class AgregationAnalytique {
  static agreger(ecritures: readonly Ecriture[]): Map<string, AgregatAnalytique> {
    const map = new Map<string, AgregatAnalytique>();
    for (const ecr of ecritures) {
      const code = ecr.axe_cdc;
      if (!code) continue;
      let agg = map.get(code);
      if (!agg) {
        agg = { code, produits: 0, charges: 0, resultat: 0 };
        map.set(code, agg);
      }
      const cls = ecr.compte.charAt(0);
      if (cls === '6') agg.charges += ecr.debit - ecr.credit;
      else if (cls === '7') agg.produits += ecr.credit - ecr.debit;
    }
    for (const agg of map.values()) {
      agg.resultat = agg.produits - agg.charges;
    }
    return map;
  }

  static filtrerParPeriodes(
    ecritures: readonly Ecriture[],
    periodes: readonly string[],
  ): Ecriture[] {
    const periodSet = new Set(periodes);
    return ecritures.filter((e) => periodSet.has(e.periode));
  }
}
